export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "تمت إضافة التصنيف بنجاح إلى حساب التداول الخاص بك.",
        ok: "جيد",
        add_account_label: "أضِف تصنيف الحساب",
        trading_account: "حساب التداول",
        select_trading_id: "حدِّد معرّف التداول",
        label: "تصنيف",
        alpha_numeric_characters : "خصِّص تصنيفًا لحسابك: (ترقيم هجائي يصل إلى 15 حرفًا)",
        apply: "تطبيق",
        cancel: "إلغاء",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "لقد تلقينا طلبك لتغيير الرافعة المالية لمعرّف التداول الخاص بك",
        from :"من",
        to :"إلى",
        confirm_mail_id:"للتأكيد، برجاء الضغط على رابط التأكيد المُرسل إليك على عنوان بريدك الإلكتروني المُسجل",
        leverage_successfully_change:"تم معالجة طلب تغيير الرافعة بنجاح",
  change_account_leverage:"تغيير رافعة الحساب",
        select_trading_account :"تحديد حساب تداول",
        existing_leverage :"رافعة حالية",
        new_leverage :"رافعة جديدة",
        select_new_leverage :"تحديد رافعة جديدة",
        change_leverage:"تغييرا الرافعة",
        account_leverage_reduced :"إذا تم خفض رافعة الحساب عن الرافعة الحالية، فستزيد الهامش المستخدم على تداولاتك المفتوحة (إن وجدت)",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:`يلزم أن تكمل "اعرف عميلك" (KYC) قبل أن تنشيء أكثر من حساب مباشر واحد`,
        submit_proof_address:"يُرجى تقديم إثبات العنوان باستخدام تذكرة الدعم ",
        click_here:"اضغط هنا",
        email_to: "أو إرسال بريد إلكتروني إلى",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "تُقبل إثباتات العنوان التالية:",
        utility_bill: "فاتورة مرافق",
        bank_statement: "كشف حساب بنكي",
        government_issued:"وثيقة ضريبة حكومية",
        note:"ملاحظة",
        proof_of_address:"يجب ألا يتجاوز إصدار إثبات العنوان 4 أشهر",
        account :"الحساب",
        select_platform:"اختر منصة",
        select_account_type:"اختر نوع الحساب",
        connect_your_account:"هل تريد ربط حسابك بحساب ZuluTrade?",
        select_leverage:"اختر الرافعة",
        select_account_base_currency:"اختر العملة الاساسية للحساب",
        select_currency:"اختر العملة",
        Password:"كلمة المرور",
        minimum_password_length5:"الحد الأدنى لطول كلمة المرور هو 5 أحرف ويجب أن يحتوي على حرف صغير على الأقل وحرف كبير ورقم وحرف خاص.",
        minimum_password_length8:"الحد الأدنى لطول كلمة المرور هو 5 أحرف ويجب أن يحتوي على حرف صغير على الأقل وحرف كبير ورقم وحرف خاص..",
        spcl_characters:"عدد الحروف",
        lowercase_letter:"الحرف الصغير",
        capital_letter:"الحرف الكبير",
        number: "رقم",
        special_character:"حرف خاص",
        confirm_password :"تأكيد كلمة المرور",
        trade_With_virtual_funds:"تداول بأموال افتراضية",
        test_strategies:"استراتيجيات اختبار مجانية",
        risk_free_trading:"تداول خالي من المخاطر",
        live_market_feed: "تحديثات السوق المباشرة",
        liquidity_from_top :"السيولة من أفضل LPs",
        effective_trading:"أدوات تداول فعالة",
        instant_execution:"تنفيذ فوري",
        low_commissions:"عمولات وفروق أسعار منخفضة",
        create_new:"أنشيء جديد",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "تفعيل المصادقة الثنائية",
        click_to_enable: "انقر للتفعيل",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"تلقينا طلبك للتحويل",
        from_trading_account:"من حساب التداول",
        to_confirm:"للتأكيد، برجاء الضغط على رابط التأكيد الذي أرسلناه إلي عنوان بريدك الإلكتروني المُسجل",
        internal_transfer_request:"طلبك للتحويل الداخلي من حساب",
        for_amount:"مبلغ",
        to_account:"إلى حساب",
        was_succesfull :" تم بنجاح تحويل مبلغ",
        internal_transfer: "التحويل الداخلي",
        transfer_From: "تحويل من",
        transfer_to:"تحويل إلى",
        balance: "الرصيد",
        enter_amount: "أدخِل المبلغ",
        USE_MAX:"استخدم MAX",
        proceed:"ابدأ",
        Internal_Transfer_ZIP:" التحويل الداخلي غير متاح لحساب .",
        In_case_of_internal_transfer:"ملاحظة: في حالة التحويلات الداخلية بين الحسابات بعملات أساسية مختلفة، فسيكون المبلغ المحوَّل حسب أسعار السوق السائدة.",
        
        /*=== manage-account.vue ====*/
        attention :"تنويه – أنت على وشك طلب مسح حساب التداول",
        note_after_requesting:"ملاحظة: - بعد الطلب، سيتم مسح حسابك من السجلات ولن تتمكن من إعادته.",
        after_clicking:"بعد الضغط على زر التأكيد، ستحصل على رابط تأكيد على عنوان بريدك الإلكتروني لمسح حساب التداول الخاص بك",
        currency: "العملة",
        Account_Type: "نوع الحساب",
        Account_Label: "تصنيف الحساب",
        Bonus: "مكافأة",
        Leverage: "رافعة مالية",
        Equity: "الأسهم",
        Create_Demo_Account: "إنشاء حساب تجريبي",
        Create_Live_Account :"إنشاء حساب مباشر",
        internal_transfer_CAP:"تحويل داخلي",
        web_trading:"التداول عبر الشبكة",
        add_account_label_CAP:"إضافة شعار الحساب",
        change_laverage:"تغيير الرافعة",
        delete_account:"مسح الحساب",
        reset_trading_password:"إعادة ضبط كلمة مرور التداول",
        
        verifying_your_request: "جارٍ التحقُّق من طلبك ...",
        success: "تم بنجاح",
        error: "خطأ",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"تلقينا طلبك لإعادة ضبط كلمة مرور المستثمر، للتأكيد، برجاء الضغط على رابط التأكيد المُرسل إلى عنوان بريدك الإلكتروني المُسجل.",
        change_investor_password:"تم تغيير كلمة مرور المستثمر بنجاح.",
        reset_investor_password:"إعادة ضبط كلمة مرور المستثمر",
        investor_password:"كلمة مرور المستثمر",
        master_password:"كلمة المرور الرئيسية",
        trading_iD: "معرِّف التداول",
        enter_new_password:"أدخِل كلمة المرور الجديدة",
        confirm_new_password :"تأكيد كلمة المرور الجديدة",
        password_must_contain:"يجب أن تحتوي كلمة مرورك على 6 حروف كحد أدنى و10 حروف كحد أقصى، ورقم واحد على الأقل، وحرف كبير وحرف خاص (!@$%*)",
        change_Password:"تغيير كلمة المرور",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"إعادة ضبط كلمة المرور الرئيسية",
        click_reset:"اضغط هنا لإعادة الضبط",
        password_caption:"كلمة مرور المستثمر هي كلمة مرور تقرأ فقط، ولا يمكن أن يستخدمها المتداول. إذا سجلت الدخول باستخدام كلمة المرور الرئيسية، فستحصل على وصول كامل وحقوق التداول في الحساب.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "شركة كبرى",
        account_type: "نوع الحساب",
        select_account_type: "حدِّد نوع الحساب",
        individual: "فردي",
        name_of_company: "اسم الشركة",
        country_of_company: "بلد الشركة",
        select_company_country: "حدِّد بلد الشركة",
        registration: "التسجيل",
        email_company: "البريد الإلكتروني الخاص بالشركة",
        Password: "كلمة المرور",
        min_password_length8: "الحد الأدنى لطول كلمة المرور هو 8 أحرف، ويجب أن يحتوي على حرف واحد صغير على الأقل وحرف واحد كبير وحرف خاص واحد.",
        spcl_characters: "عدد الحروف",
        lowercase_letter: "حرف صغير",
        capital_letter: "حرف كبير",
        number: "رقم",
        special_character: "حرف خاص",
        confirm_password: "تأكيد كلمة المرور",
        Phone_Number: "رقم الهاتف",
        have_read: "لقد قرأتُ وفهمتُ وقبلتُ",
        terms_conditions: "الأحكام والشروط",
        accept_terms_conditions: "رجاءً قبول الشروط والأحكام",
        given_your_residency: "بالنظر إلى إقامتك، سيتم تأهيلك مع شركة Triple A Experts Investment Services (GR) التي تنظمها HCMC. يمكنك عرض الحماية والشروط والأحكام المتاحة على موقعنا. بالضغط على ",
        continue: "استمرار",
        triple_investment_services: "أنت توافق على فتح حسابك مع شركة Triple A Experts Investment Services (GR).",
        register: "التسجيل",
        already_have_account: "هل لديك حساب بالفعل؟",
        login: "تسجيل الدخول",
        /*=== forgot-password.vue ====*/
        confirmation_link: "تم إرسال رابط التأكيد إلى معرِّف البريد الإلكتروني المُسجِّل الخاص بك. يُرجى الضغط على الرابط لإعادة تعيين كلمة مرور تسجيل الدخول الخاصة بك.",
        ok: "جيد",
        this_email_address: "عنوان البريد الإلكتروني هذا غير مُسجَّل لدينا.",
        click_here: "انقر هنا",
        create_account_now: "لإنشاء حساب الآن",
        forgot_password: "هل نسيت كلمة المرور",
        email_address: "عنوان البريد الإلكتروني",
        submit: "إرسال",
        dont_have_account: "ليس لديك حساب؟",
        create_account_now_CAP: "أنشئ حسابًا الآن!",
        /*=== login.vue ====*/
        client_login: "تسجيل دخول العميل",
        remember_me: "تذكرني",
        two_step_verification: "التحقُّق بخطوتين",
        google_authenticator: "رجاءً إدخال رمز المرور المعروض في تطبيق مصادقة جوجل (Google Authenticator)، مرةً واحدة.",
        google_auth_code: "رمز مصادقة جوجل",
        /*=== register.vue ====*/
        sent_an_OTP: "لقد أرسلنا رمز المرور المخصّص مرةً واحدةً إلى",
        complete_your_registration: "رجاءً إدخاله للتحقُّق وإكمال التسجيل الخاص بك.",
        otp: "رمز مرور لمرة واحدة",
        Register_heading: "التسجيل",
        first_name: "الاسم الأول",
        last_name: "اسم العائلة",
        email: "البريد الإلكتروني",
        country: "الدولة",
        select_residence_country: "حدِّد بلد الإقامة",
        privacy_policy: "سياسة الخصوصية",
        accept_privacy_policy: "رجاءً قَبول سياسة الخصوصية",
        experts_investment_services: "بالنظر إلى إقامتك، سيتم تأهيلك مع شركة Triple A Experts Investment Services (GR) التي تنظمها HCMC. يمكنك عرض الحماية والشروط والأحكام المتاحة على موقعنا. بالضغط على ",
        opening_your_account: "أنت توافق على فتح حسابك مع شركة Triple A Experts Investment Services (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "تم تغيير كلمة مرور تسجيل الدخول الخاصة بك بنجاح.",
        reset_password: "إعادة تعيين كلمة المرور",
        reset: "إعادة التعيين",
    },
    //H
    copy_trading: {
        copy_trading: "نسخ التداول",
        copy_trading_header: "حقِّق أرباحًا عن طريق نسخ تداولات مدير الإستراتيجية تلقائيًّا",
        leading_traders: "انسخ من المتداولين الرائدين تلقائيًّا",
        diversified_trading: "محفظة تداول متنوعة",
        monitor_profit: "المراقبة والربح",
        copy_traders: "كيف تنسخ التداولات؟",
        one: "1.",
        one_header: "افتح حسابًا مباشرًا وابدأ الإيداع.",
        two: "2.",
        two_header: "اختر مدير الإستراتيجية.",
        three: "3.",
        three_header: "وافِق على الشروط والأحكام.",
        four: "4.",
        four_header: "أعطنا موافقتك.",
        five: "5.",
        five_header: "اكسب الأرباح عن طريق نسخ التداولات.",
        order_processing: "معالجة الطلب السريع",
        end_result: "السيطرة على النتيجة النهائية",
        trading_skills: "ترقية مهاراتك في التداول",
        start: "ابدأ"
    },
    downloads: {
        mt_four_desktop: "منصة MT4 للحاسوب",
        mt_four_android: "منصة MT4 للهواتف التي تعمل بنظام التشغيل Android",
        mt_four_ios: "منصة MT4 للهواتف التي تعمل بنظام التشغيل iOS",
        mt_four_web_trader: "منصة MT4 للتداول عبر الإنترنت",
        mt_five_desktop: "منصة MT5 للحاسوب",
        mt_five_android: "منصة MT5 للهواتف التي تعمل بنظام التشغيل Android",
        mt_five_ios: "منصة MT5 للهواتف التي تعمل بنظام التشغيل iOS",
        mt_five_web_trader: "منصة MT5 للتداول عبر الإنترنت",
        act_trader_desktop: "منصة Act Trader للحاسوب",
        act_trader_android: "منصة Act Trader للهواتف التي تعمل بنظام التشغيل Android",
        act_trader_ios: "منصة Act Trader للهواتف التي تعمل بنظام التشغيل iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "هل أنت متأكد أنك تريد الاستفادة من حزمة الخادم الافتراضي الخاص",
        package: "(VPS)؟",
        yes: "نعم",
        no: "لا",
        downloads: "التنزيلات",
        copy_trading: "نسخ التداول",
        vps: "VPS"
    },
    vps: {
        vps_plans: "خطط VPS",
        bronze: "الفئة البرونزية",
        monthly_subscription_twenty_five: "اشتراك شهري قيمته 25 دولارًا",
        free_deposit_five_thousand: "احصل عليه مجانًا عند إيداع 5000 دولار أو أكثر",
        compatible_mt_four_five_act: "متوافق مع منصات MT4 وMT5 وAct",
        free_twenty_five_gb_disk_space_ram_vcpu: "مساحة التخزين المجانية 25 جيجابايت | 1300 ميجابايت من ذاكرة الوصول العشوائي | وحدة معالجة مركزية افتراضية VCPU واحدة",
        windows_linux_support: "نظام التشغيل Windows 8/10/12، يدعم لينكس (Linux)",
        avail_now: "متوفر الآن",
        silver: "الفئة الفضية",
        monthly_subscription_fourty_five: "اشتراك شهري 45 دولارًا",
        free_on_deposit_ten_thousand: "احصل عليه مجانًا عند إيداع 10,000 دولار أو أكثر",
        free_fifty_gb_disk_space_ram_vcpu: "مساحة التخزين المجانية 50 جيجابايت | 2700 ميجابايت من ذاكرة الوصول العشوائي | وحدتا معالجة مركزية افتراضية VCPU",
        gold: "الفئة الذهبية",
        monthly_subscription_eighty: "اشتراك شهري 80 دولارًا",
        free_on_deposit_fifteen_thousand: "احصل عليه مجانًا عند إيداع 15000 دولار أو أكثر",
        free_seventy_five_gb_disk_space_ram_vcpu: "مساحة تخزين حرة 75 جيجابايت | ذاكرة الوصول العشوائي 5120 ميجابايت | 3 وحدات معالجة مركزية افتراضية"
    },
    ticket_details: {
        cancel_withdrawal_request: "إلغاء طلب السحب",
        cancel_your_withdrawal_request: "هل أنت متأكد من أنك تريد إلغاء طلب السحب الخاص بك؟",
        process_request: "طلب المعالجة",
        open_tickets: "التذاكر المفتوحة",
        back: "رجوع",
        ticket_number: "رقم التذكرة:",
        created: "تم إنشاء:",
        reason: "السبب:"
    },
    bonus: {
        request_to_avail_bonus: "طلبك للاستفادة من مكافأة",
        trading_id: "لمعرِّف التداول",
        click_confirmation_link: "تم استلامه. للتأكيد، يُرجى الضغط على رابط التأكيد المُرسل إلى معرّف بريدك الإلكتروني المُسجل.",
        request_to_remove_bonus: "طلبك لإزالة مكافأة",
        bonus_amount: "مبلغ مكافأتك",
        successfully_removed_account: "تمت إزالته بنجاح من معرّف الحساب",
        ok: "جيد",
        request_to_add_bonus: "طلبك لإضافة مكافأة",
        successfully: "تم بنجاح.",
        bonus: "المكافأة",
        select_trading_id: "حدِّد معرّف التداول",
        use_max: "استخدِم Max",
        account_type: "نوع الحساب",
        equity: "الأسهم",
        leverage: "رافعة مالية",
        currency: "العملة",
        current_bonus: "المكافأة الحالية",
        allowed_bonus: "المكافأة المسموح بها",
        remove: "إزالة",
        account_first: "رجاءً تحديد حساب أولاً",
        bonus_amount_base_currency: "ملحوظة: أدخِل مبلغ المكافأة بالعملة الأساسية.",
        point_one: "1. عرض مكافأة 100٪ متاح لجميع العملاء الذين يودعون حدًّا أدنى قدره 100 دولار أمريكي ورافعة مالية تصل إلى 1:200. الحد الأقصى للمكافأة المسموح بها هو40,000 دولار أمريكي لكل عميل.",
        point_two: "2. الأرباح المحقَّقة من الصفقات من خلال مكافأتنا ستكون كلها ملكك. لن يتم خصم المكافأة إذا سحبت أرباحك.",
        point_three: "3. تعزز المكافأة الهامش المتاح في الحساب. ومع ذلك، لا يمكن تغطية خسائرك بالمكافأة. إذا تجاوز إجمالي الخسائر في تداولاتِك أموالَك الخاصة، فسيوقف النظام تلقائيًّا الصفقات في حساب التداول الخاص بك دون أي إشعار مُسبق.",
        point_four: "4. سيتم سحب مبلغ المكافأة المتناسب من حسابك إذا سحبت أموالك الخاصة.",
        read_understood_accepted: "لقد قرأتُ وفهمتُ وقبلتُ",
        aaafx_bonus_policy: "سياسة مكافآت AAAFx.",
        accept_aaafx_bonus_policy: "يُرجى قبول سياسة المكافأة من AAAFx",
        proceed: "الاستمرار",
        no_bonus_available_account: "لا توجد مكافآت متاحة لهذا الحساب"
    },
    refer_earn: {
        bonus: "المكافأة",
        refer_earn: "الدعوة والربح",
        refer_friend: "دعوة صديق",
        earn_dollar_twenty_five: "اكسب 25 دولارًا",
        per_friend: "لكل صديق",
        why_refer_someone_to_us: "لماذا عليك دعوة أحد لدينا؟",
        refer_someone_point_one: "1. ستستفيد أنت وصديقك من مكافأة الدعوة.",
        refer_someone_point_two: "2. إجراء مباشر وسريع",
        refer_someone_point_three: "3. ستستفيدان من شروط التداول الملائمة لدينا.",
        refer_someone_point_four: "4. الأرباح من الدعوات لا حدود لها.",
        what_need_to_do: "هذا ما عليك القيام به:",
        what_need_to_do_point_one: "1. شارِك رابط الدعوة الخاص بك مع شركائك.",
        what_need_to_do_point_two: "2. سجِّل دعواتك باستخدام الرابط الخاص بك وابدأ التداول.",
        what_need_to_do_point_three: "3. بمجرد أن تتأهل دعوتك، سيحصل كل منكما على 25 دولارًا.",
        referral_list: "قائمة الدعوات الخاصة بك"
    },
    referral_list: {
        referrals_list: "قائمة الدعوات",
        list_of_referrals: "قائمة الدعوات لتتبع أرباحك.",
        s_no: "الرقم التسلسلي",
        name: "الاسم",
        email_id: "معرّف البريد الإلكتروني",
        account_stage: "مرحلة الحساب",
        deposits: "الودائع",
        volume_required: "الحجم المطلوب",
        traded_volume: "حجم التداول",
        qualified: "المؤهَّل",
        no_data: "لا توجد بيانات",
        payment_of_referral_bonus: "تُدفع مكافأة الدعوة في الأسبوع الذي يلي أسبوع تأهل الدعوة.",
        referral_bonus_paid_in_aaafx_wallet: "تُدفع مكافأة الدعوة في محفظة AAAFx بالدولار الأمريكي، ليتمكن الداعي والمدعو من سحبها أو تحويلها إلى حساب التداول الخاص بهما.",
        read_all_terms_conditions: "اقرأ جميع الشروط والأحكام",
        here: "هنا",
        contact_us: "هل لديك أسئلة؟ تواصَل معنا عبر الدردشة المباشرة على مدار الساعة/خمسة أيام في الأسبوع أو راسلِنا على",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "التعريفات",
        meaning_of_all_above_columns: "فيما يلي معنى جميع الأعمدة أعلاه للرجوع إليها:",
        name_of_your_referral: "- اسم المدعو الخاص بك.",
        meaning_of_various_stages: "- يُرجى الاطلاع أدناه على معنى مختلف المراحل.",
        registered: "1. مُسجَّل:",
        registered_link: "تم تسجيل دعوتك باستخدام الرابط الخاص بك.",
        funded: "2. مموَّل:",
        referral_deposited: "تم إيداع دعوتك.",
        third_point_qualified: "3. مؤهَّل:",
        referral_has_deposited: "تم إيداع دعوتك ووصلت إلى حجم التداول المطلوب. كلاكما مؤهل الآن للحصول على المكافأة.",
        deposits_made_by_referral: "- الإيداعات التي تمت بدعوتك.",
        volume_requirement: "متطلبات الحجم",
        volume_required_for_reward: "- الحجم المطلوب لدعوتك للتأهل للمكافأة.",
        volume_your_referral_traded: "- الحجم الذي تداوله متلقي الدعوة بالفعل.",
        referral_qualified_for_reward: "- ما إذا كان متلقي الدعوة مؤهَّلًا لمتطلبات المكافأة أم لا.",
        referral_ib_programs: `بعد ربح مكافآت على 10 دعوات، يمكنك أن تصبح إما IB أو تستمر في برنامج "أرسل دعوة واكسب" بمكافأة 20 دولار لك ولمستلم الدعوة. يمكنك مقارنة فوائد وخصائص برامج الدعوة وIB الخاصة بنا.`
    },
    calculators_common: {
        asset_class: "فئة الأصول",
        forex: "فوركس",
        commodities: "السلع",
        indices: "المؤشرات",
        account_base_currency: "العملة الأساسية للحساب",
        usd: "دولار أمريكي",
        gbp: "جنيه إسترليني",
        aud: "دولار أسترالي",
        eur: "يورو",
        symbol: "الرمز",
        select_symbol: "حدِّد الرمز",
        trade_size_in_lots: "حجم التداول (باللوت)",
        calculate: "احسب"
    },
    margin: {
        margin_required: "الهامش المطلوب:",
        maximum_leverage: "الرافعة المالية القصوى:"
    },
    pip: {
        pip_value: "Pip قيمة:"
    },
    swap: {
        server: "الخادم",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "عدد الأيام",
        long_swap: "مقايضة طويلة:",
        short_swap: "مقايضة قصيرة:"
    },
    //S
    dashboard:{
        select_trading_id: "حدِّد معرّف التداول",
        leverage: "رافعة مالية",
        balance: "الرصيد",
        equity: "الأسهم",
        free_margin: "الهامش الحر",
        pnl: "PNL",
        web_trader : "منصة التداول عبر الإنترنت",
        fund: "الأموال",
        promotions: "الترقيات",
        hundred: "100",
        bonus: "مكافأة",
        avail: "فائدة",
        deposit_bonus: "مكافأة الإيداع",
        loading_initial_data: "تحميل البيانات الأولية",
    },
    enable_2fa:{
        title: "مصادقة جوجل الثنائية (2FA)",
        description: "لتمكين مصادقة جوجل الثنائية (2FA)، امسح رمز الاستجابة السريعة وأدخِل رمز المرور الذي تم إنشاؤه لمرة واحدة أدناه.",
        google_authenticator_code: "رمز مصادقة جوجل",
        how_to_enable: "لتمكين المصادقة الثنائية:",
        download: "التنزيل",
        google_authenticator_app: "تطبيق مصادقة جوجل",
        on_mobile_tablet: "على هاتفك المحمول/ جهازك اللوحي.",
        scan_the : "امسح",
        qr_code: "رمز الاستجابة السريعة",
        appearing_above: "الظاهر أعلاه",
        enter_the: "أدخِل",
        passcode: "رمز المرور",
        appers_in_google_auth_app: "الذي يظهر في تطبيق مصادقة جوجل الخاص بك",
        click_on_the_button: "انقر على الزر",
        click_to_enable: "انقر للتفعيل",
    },
    account_security:{
        title: "مصادقة جوجل الثنائية (2FA)",
        description: "لتمكين مصادقة جوجل الثنائية (2FA)، امسح رمز الاستجابة السريعة وأدخِل رمز المرور الذي تم إنشاؤه لمرة واحدة أدناه.",
        google_authenticator_code: "رمز مصادقة جوجل",
        how_to_enable: "لتمكين المصادقة الثنائية:",
        download: "التنزيل",
        google_authenticator_app: "تطبيق مصادقة جوجل",
        on_mobile_tablet: "على هاتفك المحمول/ جهازك اللوحي.",
        scan_the : "امسح",
        qr_code: "رمز الاستجابة السريعة",
        appearing_above: "الظاهر أعلاه",
        enter_the: "أدخِل",
        passcode: "رمز المرور",
        appers_in_google_auth_app: "الذي يظهر في تطبيق مصادقة جوجل الخاص بك",
        click_on_the_button: "انقر على الزر",
        click_to_enable: "انقر للتفعيل",
    },
    change_pass:{
        success_message:"تم تغيير كلمة مرورك بنجاح.",
        ok:"حسنًا",
        change_password: "تغيير كلمة المرور",
        existing_password: "كلمة المرور الحالية",
        new_password: "كلمة مرور جديدة",
        confirm_new_password: "تأكيد كلمة المرور الجديدة",
        note_one: "يجب أن تحتوي كلمة المرور على 7 أحرف كحد أدنى و10 أحرف كحد أقصى، ويجب أن تتضمن رقمًا واحدًا على الأقل وحرفًا كبيرًا وحرفًا خاصًّا واحدًا {'(! @ # $٪ ^)'}.",
        note_two: "يُرجى ملاحظة أن كلمة مرور الملف الشخصي مختلفة عن كلمة مرور حساب التداول الخاص بك",
        cancel: "إلغاء",
    },
    corporate_varify_step_three:{
        please_upload_file: "رجاءً تحميل الملف",
        out_of_documents: "من أصل 8 وثائق",
        add_file: "أضِف ملفًا",
        max_file_size: "الحجم الأقصى للملفات التي يمكن رفعها يصل إلى"
    },
    corporate_varify:{
        corporation_info: 'معلومات الشركة',
        account_creation: "إنشاء حساب",
        verification: "التَحَقّق",
        deposit: "إيداع",
        select_platform: "حدِّد منصة",
        select_account_type: "حدِّد نوع الحساب",
        select_leverage: "حدِّد الرافعة المالية",
        select_base_currency: "حدِّد عملة الحساب الأساسية",
        select_currency: "اختر العملة",
        password: "كلمة المرور",
        pass_length_alert: "الحد الأدنى لطول كلمة المرور هو 5 أحرف، ويجب أن يحتوي على حرف واحد صغير على الأقل ورقم واحد كبير وحرف خاص واحد.",
        of_characters: "من الحروف",
        lowercase_letter: 'حرف صغير',
        capital_letter : "حرف كبير",
        number: "رقم",
        special_character : "حرف خاص",
        confirm_password: "تأكيد كلمة المرور",
        create_account : "إنشاء حساب",
    },
    corporation_info:{
        name_of_company: "اسم الشركة",
        country_of_company: "بلد الشركة",
        select_company_country: "حدِّد بلد الشركة",
        registration: "التسجيل",
        submit: "إرسال",
    },
    profile:{
        personal_details: "تفاصيل شخصية",
        uploaded_documents: "المستندات التي تم تحميلها",
        no_documents_yet: "لا توجد مستندات حتى الآن",
    },
    questions:{
        financial_details: "التفاصيل المالية",
        sub_heading_one: "إجمالي الدخل السنوي المُقدر",
        select_annual_income: "حدِّد الدخل السنوي",
        sub_heading_two: "إجمالي القيمة الصافية المُقدرة",
        sub_heading_two_desc: "إجمالي الأصول مطروحًا منه إجمالي التزامات الفرد أو الشركة.",
        select_net_worth:"حدد صافي القيمة",
        sub_heading_three: "مجال العمل",
        select_occupation: "حدِّد المهنة",
        sub_heading_four: "أدخِل مهنة أخرى",
        sub_heading_five: "مصادر الأموال",
        sub_heading_six: "أدخِل مصادر الأموال الأخرى",
        sub_heading_seven: "الشخص الواجب الإبلاغ عنه بموجِب قانون الامتثال الضريبي للحسابات الأجنبية الأمريكية",
        sub_heading_eight: "البلد/ الولاية القضائية للإقامة الضريبية",
        select_residence_country: "حدِّد بلد الإقامة",
        sub_heading_nine: "هل تمتلك رقم التعريف الضريبي؟",
        sub_heading_ten: "أدخِل رقم التعريف الضريبي",
        sub_heading_eleven: "إذا لم يكن رقم التعريف الضريبي متاحًا، فأدخِل السبب",
        select_reasons: "حدِّد الأسباب",
        enter_reason: "أدخِل السبب",
        submit: "إرسال",
        dear: "عزيزي",
        message_one: "بناءً على المعلومات التي قدمتها، يبدو أنك مُقيم في الولايات المتحدة لأغراض ضريبية.",
        message_two: "يُرجى ملاحظة أنه نظرًا لامتثالنا التنظيمي، فإن AAAFx غير قادرة على قبول عميل مُقيم في الولايات المتحدة لأغراض ضريبية.",
        message_three: "نشكركم مقدمًا على تفهمك.",
        message_four: "تفضلوا بقَبول فائق الاحترام،",
        message_five: "AAAFx",
        close: "إغلاق",
    },
    verify:{
        account_creation: "إنشاء حساب",
        financial_details: "التفاصيل المالية",
        verification: "التَحَقّق",
        deposit: "إيداع",
        select_platform: "حدِّد منصة",
        select_account_type: "حدِّد نوع الحساب",
        select_leverage: "حدِّد الرافعة المالية",
        select_base_currency: "حدِّد عملة الحساب الأساسية",
        select_currency: "اختر العملة",
        password: "كلمة المرور",
        pass_message_one: "الحد الأدنى لطول كلمة المرور هو 5 أحرف، ويجب أن يحتوي على حرف واحد صغير على الأقل ورقم واحد كبير وحرف خاص واحد.",
        pass_message_two: "الحد الأدنى لطول كلمة المرور هو 8 أحرف، ويجب أن يحتوي على حرف واحد صغير على الأقل وحرف واحد كبير وحرف خاص واحد.",
        of_characters: "من الحروف",
        lowercase_letter: "حرف صغير",
        capital_letter: "حرف كبير",
        number: "رقم",
        special_character: "حرف خاص",
        confirm_password: "تأكيد كلمة المرور",
        create_account: "إنشاء حساب",
        doc_message_one: "تم رفض المستندات التي قدمتها عن طريق عملية التحقق الآلي. تم إنشاء تذكرة تتعلق بالشيء نفسه، حيث يمكنك إعادة تحميل مستنداتك للتحقق يدويًّا من المستندات إذا كنت ترغب في ذلك.",
        view_ticket: "عرض التذكرة",
    },
    verify_quest_bkp:{
        account_creation: "إنشاء حساب",
        questionnaire: "الاستبيان",
        verification: "التَحَقّق",
        deposit:"Deposit",
        select_platform: "حدِّد منصة",
        select_account_type: "حدِّد نوع الحساب",
        select_leverage: "حدِّد الرافعة المالية",
        select_base_currency: "حدِّد عملة الحساب الأساسية",
        select_currency: "اختر العملة",
        password: "كلمة المرور",
        pass_length_alert: "الحد الأدنى لطول كلمة المرور هو 5 أحرف، ويجب أن يحتوي على حرف واحد صغير على الأقل ورقم واحد كبير وحرف خاص واحد.",
        of_characters: "من الحروف",
        lowercase_letter: "حرف صغير",
        capital_letter: "حرف كبير",
        number: "رقم",
        special_character: "حرف خاص",
        confirm_password: "تأكيد كلمة المرور",
        create_account: "إنشاء حساب",
        doc_message_one: "تم رفض المستندات التي قدمتها عن طريق عملية التحقق الآلي. تم إنشاء تذكرة تتعلق بالشيء نفسه، حيث يمكنك إعادة تحميل مستنداتك للتحقق يدويًّا من المستندات إذا كنت ترغب في ذلك.",
        view_ticket: "عرض التذكرة",
    },
    close_ticket:{
        heading: "التذاكر المغلقة",
        create_request: "إنشاء طلب",
        open_tickets: "التذاكر المفتوحة",
        ticket_number: "رقم التذكرة",
        trading_id: "معرِّف التداول",
        status: "حالة",
        subject: "الموضوع",
        created: "تم إنشاؤه",
        closed: "مغلق",
        action: "الإجراء",
        view_ticket: "عرض التذكرة",
        no_tickets_found: "لم يتم العثور على تذاكر",
    },
    open_ticket:{
        heading: "التذاكر المفتوحة",
        create_request: "إنشاء طلب",
        open_tickets: "التذاكر المفتوحة",
        closed_ticket: "التذاكر المغلقة",
        ticket_number: "رقم التذكرة",
        trading_id: "معرِّف التداول",
        status: "حالة",
        subject: "الموضوع",
        created: "تم إنشاؤه",
        action: "الإجراء",
        view_ticket: "عرض التذكرة",
        no_tickets_found: "لم يتم العثور على تذاكر",
    },
    request_call:{
        success_message:"استلمنا طلبك بتلقي مكالمة هاتفية، سيتواصل معك فريقنا قريبًا.",
        ok: "جيد",
        request_call_back:"طلب معاودة الاتصال",
        first_name: "الاسم الأول",
        last_name: "اسم العائلة",
        email_id: "معرّف البريد الإلكتروني",
        phone_number: "رقم الهاتف",
        timezone: "المنطقة الزمنية",
        date: "التاريخ",
        preferred_time: "الوقت المفضل",
        department: "القِسم",
        select_department: "حدِّد القسم",
        new_accounts: "حسابات جديدة",
        deposits: "الودائع",
        withdrawals: "عمليات السحب",
        partnership: "الشراكة",
        technical_support: "الدعم الفني",
        message: "رسالة",
        send_request: "أرسِل طلبًا",
    },
    support_page:{
        success_message:"تم إنشاء تذكرة دعم لك بنجاح. يمكنك تعقبها في التذاكر المفتوحة..",
        ok:"حسنًا",
        support: "الدعم",
        create_req:"إنشاء طلب",
        open_tickets:"التذاكر المفتوحة",
        closed_tickets: "التذاكر المغلقة",
        otp_msg:"أرسلنا لك رمز مرور لمرة واحدة إلى بريدك الإلكتروني المُسجل. يُرجى فتحه للتحقق من طلب تذكرة الدعم.",
        otp: "رمز مرور لمرة واحدة",
        submit: "إرسال",
        reason: "السبب",
        select_a_reason: "حدِّد سبب",
        trading_id: "معرِّف التداول",
        select_trading_account: "حدِّد حساب التداول",
        subject: "الموضوع",
        trade_order_id: "معرّف أمر التداول",
        time_of_trade_opening: "وقت افتتاح التداول",
        time_of_trade_closing: "وقت إغلاق التداول",
        instrument_traded: "الأداة المتداولة",
        type_of_trade: "نوع التداول",
        select_trade_type: "حدِّد نوع التداول",
        details_of_the_issue: "تفاصيل المشكلة",
        refund_claim_amount: "مبلغ المطالبة بالاسترداد",
        message: "رسالة",
        note: "ملحوظة",
        file_attachments: "الملفات المرفقة",
        file_size_msg: "يجب ألا يزيد حجم المستند على 1 ميجابايت",
        file_format_msg: "تنسيق الملف (jpeg أو pdf) فقط",
        lowercase_note: "ملحوظة",
        note_desc: "في حالة حدوث أي خطأ في أثناء إجراء أي عملية من عمليات الحساب، يُرجى إرفاق لقطة الشاشة أيضًا خلال إنشاء التذكرة",
        create_support_request: "إنشاء طلب دعم",
    },
    become_ib:{
        heading: "إدخال وسيط",
        description: "عزِّز أرباحك من خلال برنامج إدخال الوسيط (IB) الخاص بنا. <br />احصل على رابطك المُخصّص، وشارِكه مع أصدقائك واكسب عمولات كلما تداولوا.",
        sub_heading: "نقدم فئتين من برامج إدخال الوسيط:",
        point_one: "برنامج إدخال الوسيط القياسي - احصل مباشرةً على 20٪ من أرباح عمولاتنا من عملائك. هذا مفيد لإدخال الوسيط المبتدئ الذي يريد أن يبدأ من جديد أو يمكنه البدء في جلب عدد محدود من العملاء إلينا.",
        point_two: "برنامج إدخال الوسيط المتقدم -هذا برنامج إدخال وسيط مُخصص ومجزٍ للغاية للوسطاء المُدخلين الأكبر لدينا. هذا مفيد لشخص لديه قاعدة عملاء كبيرة بإمكانه جلب عددٍ أكبر.",
        note_one: "يمكنك الانتقال من برنامج إدخال الوسيط القياسي إلى برنامج إدخال الوسيط المتقدم، بمجرد أن تجعل شبكتك كبيرةً بما يكفي.",
        earn_with: "اكسب مع",
        zero_investment_or: "صفر استثمار أو",
        experience: "خبرة",
        weekly_ib: "برنامج إدخال الوسيط الأسبوعي",
        commissions: "العمولات",
        payouts: "المدفوعات",
        unlimited: "غير محدود",
        earnings: "الأرباح",
        potential: "محتمل",
        sub_cont_point_four: "برنامج إدخال الوسيط المتقدم مخصَّص ومجزٍ للغاية",
        ultra_fast: "فائق السرعة",
        withdrawals_of_ib: "عمليات سحب برنامج إدخال الوسيط",
        commission: "العمولة",
        easy_user: "واجهة مستخدم",
        interface_of: "سهلة",
        ib_portal: "لمنصة إدخال الوسيط",
        dedicated: "مُخصَّصة",
        account: "مدير",
        manager: "الحساب",
        helpful_and: "مفيد",
        free_marketing: "وتسويق مجاني",
        material: "أساسي",
        become_an_ib: "انضم إلى برنامج إدخال الوسيط",
    },
    pamm_acct:{
        title:"PAMM حساب",
        description_one: "PAMM (وحدة إدارة تخصيص النسبة المئوية) هو حساب إداري يقوم فيه المدير بإتمام التداولات في جميع حساباته الفرعية. المدير والمستثمرون لديهم حرية اختيار هيكل رسوم الأداء، وسنعمل على وضعه موضع التنفيذ.",
        description_two: "توفِّر AAAFx حلول تداول PAMM عالية المرونة ومخصَّصة.",
        sub_title: "كيفية التسجيل كمدير PAMM",
        sub_Point_one: "يمكن فتح حساب مدير PAMM الخاص بك بمجرد أن يكون لديك أربعة مستثمرين على الأقل بإيداع إجمالي يبلغ 5000 دولار أو أكثر.",
        sub_Point_two: "ما عليك سوى التسجيل بصفتك IB لتصبح مدير PAMM معنا. سجِّل عملاءك باستخدام رابط IB الخاص بك، وتلبية الشرط الأول أعلاه.",
        sub_Point_three: "تواصَل معنا عبر الدردشة المباشرة أو راسِلنا عبر البريد الإلكتروني على",
        sub_Point_four: "ابدأ في كسب عمولات IB بالإضافة إلى رسوم أداء PAMM.",
        minimul_investment: "الحد الأدنى من الاستثمار",
        ease_of_access: "سهولة الوصول",
        ultimate_trading_conditions: "شروط التداول المطلقة",
        trade_security: "أمن التداول",
        request_pamm: "طلب PAMM",
    },
    add_payment_methods:{
        success_message: "تمت إضافة طريقة الدفع الخاصة بك بنجاح. يمكنك تعقُّبه من خلال التذاكر المفتوحة.",
        ok: "جيد",
        otp_message: "لقد أرسلنا رمز المرور مرةً واحدةً إلى بريدك الإلكتروني المُسجَّل. رجاءً إدخاله للتحقُّق من طلب تذكرة الدعم.",
        otp: "رمز مرور لمرة واحدة",
        submit: "إرسال",
        page_heading: "أضِف طرق الدفع",
        select_payment_method: "اختَر طريقة الدفع",
        select_method: "اختَر طريقة",
        bank: "البنك",
        credit_card: "بطاقة الائتمان",
        crypto: "العملة المشفرة",
        select_crypto_currency: "حدِّد العملة المشفرة",
        select_crypto: "حدِّد التشفير",
        btc: "البيتكوين (BTC)",
        eth: "إيثريوم (ETH)",
        usdt: "عملة تيثر مرتبطة بالدولار الأمريكي (USDT)",
        usdc: "عملة مشفرة مرتبطة بالدولار الأمريكي (USDC)",
        add_your_bank_details: "أضِف تفاصيل البنك الخاص بك",
        bank_name: "اسم البنك",
        account_name: "اسم الحساب",
        account_number: "رقم الحساب",
        country: "الدولة",
        select_country: "حدِّد الدولة",
        iban: "رقم الحساب المصرفي الدولي (IBAN)",
        iban_note: "لا يُصدر المصرف الذي أتعامل معه IBAN",
        swift: "الصيغة الموحدة للرمز التعريفى للبنك (السويفت)",
        bic: "رمز معرّف الأعمال (BIC)",
        sort_code: "رمز الفرز",
        bank_address: "عنوان البنك",
        upload_your_bank_statement: "حمِّل كشف الحساب المصرفي الخاص بك",
        upload_doc_info_one: "يجب ألا يزيد حجم المستند على 1 ميجابايت",
        upload_doc_info_two: "تنسيق الملف (jpeg أو pdf) فقط",
        note: "ملحوظة",
        note_msg: "في حالة حدوث أي خطأ في أثناء إجراء أي عملية من عمليات الحساب، يُرجى إرفاق لقطة الشاشة أيضًا خلال إنشاء التذكرة",
        create_support_request: 'أنشئ طلب دعم',
        add_your_card_details: "أضِف تفاصيل بطاقتك",
        creadit_card_number: "رقم البطاقة الائتمانية",
        month: "الشهر",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "سنة",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "رمز التحقق من البطاقة (CVV)",
        varification_msg: "نطلب ما يلي للتحقُّق من البطاقة",
        varification_msg_one: "نسخة ملوَّنة من الوجه الأمامي للبطاقة، تظهِر: الاسم الكامل، وتاريخ انتهاء الصلاحية، واسم/ شعار البنك، وأول وآخر 4 أرقام من رقم بطاقة الائتمان تخفي الأرقام الثمانية الوسطى.",
        upload_supporting_document: "تحميل المستند الداعم",
        varification_msg_two: "نسخة ملوَّنة من الجانب الخلفي للبطاقة لإخفاء رمز أمان CVV. يجب أن تظهِر النسخة الخلفية توقيعَ صاحبها",
        add_selected_crypto_address: "أضِف عنوان التشفير المُحدد",
        address: "العنوان",
    },
    deposit:{
        account_type: "نوع الحساب",
        select_type: "اختَر الصنف",
        live: "مباشر",
        trading_account: "حساب التداول",
        select_trading_account: "حدِّد حساب التداول",
        balance: "الرصيد",
        fund: "الأموال",
        amount: "المبلغ",
        region: "المنطقة",
        currencies: "العملات",
        processing_time: "وقت المعالجة",
        action: "الإجراء",
        view_more: "عرض المزيد",
        currency: "العملة",
        zar: "راند جنوب أفريقي",
        swift_code: "رمز السويفت",
        beneficiarys_name: "اسم المستفيد",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "رقم الحساب",
        user_account_number: "62928423269",
        bank_address: "عنوان البنك",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "اسم البنك",
        bank_name_info: "شركة DIXIPAY المحدودة",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "رقم الحساب المصرفي الدولي (IBAN)",
        iban_no: "GB78DIXP00997890200462",
        eur: "يورو",
        city: "مدينة",
        city_info: "لندن",
        country: "الدولة",
        country_info: "المملكة المتحدة",
        dixipay_note: "تقبل Dixipay الودائع فقط باليورو",
        you_can_deposit: "يمكنك الإيداع",
        you_can_deposit_msg: "في العنوان التالي، وستتم إضافة المبلغ المعادل بعملة الحساب المُحددة بعد التحويل",
        copy: "النسخ",
        done: "انتهى",
        network_msg: "شبكة ERC-20 (عملة تيثر، العملة المستقرة، إيثريوم) مدعومة، ولن يصل استخدام أي شبكة أخرى إلينا.",
    },
    fund_index: {
        add_funds: "إضافة الأموال",
        cancel: "إلغاء",
        ok: "جيد",
        your_request_to_add: "تم استكمال طلبك لإضافة",
        to_your_demo_account_number: "إلى رقم حسابك التجريبي",
        has_been_successfully_completed: "بنجاح",
        your_request_to_withdraw: "تم استلام",
        from_the_trading_id: "طلبك للسحب",
        has_been_received: "من معرّف التداول",
        click_to_proceed_withdrawal: "يُرجى النقر فوق رابط التأكيد المرسل إلى معرّف البريد الإلكتروني المُسجَّل الخاص بك لمعالجة عملية السحب",
        has_been_successfully: "تم بنجاح",
        your_request_to_add_usd: "طلبك لإضافة دولار أمريكي",
    },
    request_verify: {
        verifying_your_request: "جارٍ التحقُّق من طلبك",
        success: "تم بنجاح",
        go_to_transactions: "انتقل إلى المعاملات",
        error: "خطأ",
    },
    transactions: {
        list_of_transactions: "قائمة المعاملات",
        deposits: "الودائع",
        withdrawals: "عمليات السحب",
        bonus: "مكافأة",
        deposit_transactions: "معاملات الإيداع",
        filter_by: "مصنَّف بواسطة",
        select_trading_id: "حدِّد معرّف التداول",
        all: "الجميع",
        date: "التاريخ",
        account_id: 'Account ID',
        currency: "العملة",
        payment_mode: "طريقة الدفع",
        deposit_amount: "قيمة الإيداع",
        status: 'Status',
        no_deposits_yet: "لا توجد ودائع حتى الآن",
        withdrawal_mode: "وضع السحب",
        withdrawal_amount: "مبلغ السحب",
        action: "الإجراء",
        view_more : "عرض المزيد",
        no_withdrawals_yet: "لا توجد عمليات سحب حتى الآن",
        bonus_amount: "مبلغ المكافأة",
        pending : "قيد الانتظار",
        no_bonus_transactions_yet: "لا توجد معاملات مكافأة حتى الآن",
        deposit_currency: "عملة الإيداع",
        account_currency: 'عملة الحساب',
        address: 'العنوان',
    },
    withdrawal: {
        kyc_req_msg: `من الضروري إكمال "اعرف عميلك" قبل طلب السحب. يُرجى تقديم إثبات العنوان باستخدام تذكرة دعم`,
        Click_here: "انقر هنا",
        or_email_to: 'إرسال بريد إلكتروني إلى',
        with_step_heading: "تُقبل إثباتات العنوان التالية",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "فاتورة مرافق",
        with_step_two: "كشف حساب بنكي",
        with_step_three: "مستند ضريبي صادر عن الحكومة",
        note: "ملحوظة",
        note_info: "يجب ألا يزيد عمر إثبات العنوان على 4 أشهر",
        ok: "جيد",
        enable_2fa_msg: "من الضروري تمكين المصادقة الثنائية (2FA) لرفع طلب السحب. رجاءً الضغط على الزر التالي",
        click_to_enable: "انقر للتفعيل",
        select_trading_id: "حدِّد معرّف التداول",
        account_id: "معرّف الحساب",
        account_type: "نوع الحساب",
        platform: 'المنصة',
        leverage: "رافعة مالية",
        currency: "العملة",
        free_margin: "الهامش الحر",
        note_info_two: "أدخِل مبلغ السحب بالعملة الأساسية لحساب التداول (TradingAccount) الخاص بك.",
        amount: "المبلغ",
        mode_of_payment: "طريقة الدفع",
        create_transaction: "إنشاء معاملة",
        cancel: "إلغاء",
        add_payment_method: "أضِف طريقة الدفع",
        no_amount_available: "لا يوجد مبلغ متاح في هذا الحساب",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "حدِّد حساب",
    },
    footer: {
        legal_information: "المعلومات القانونية",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. مرخَّصة ومنظَّمة من قِبل هيئة سلوك القطاع المالي في جنوب إفريقيا (FSCA رقم 2017/315029/07).",
        risk_warning: "تحذير من المخاطر",
        risk_warning_info: `ينطوي تداول العملات الفورية على مخاطر كبيرة وهناك دائمًا احتمال الخسارة. قد تختلف نتائج تداولك. نظرًا لأن عامل المخاطرة مرتفع في تداول سوق الصرف الأجنبية، يجب استخدام أموال "المخاطرة" الحقيقية فقط في مثل هذا التداول. إذا لم يكن لديك رأس مال إضافي يمكنك تحمُّل خسارته، يجب ألا تتداول في سوق الصرف الأجنبية. لم يتم ابتكار أي نظام تداول "آمن" على الإطلاق، ولا يمكن لأحد أن يضمن الأرباح أو التحرر من الخسارة.`,
    },
    header: {
        welcome: "مرحبًا", 
        profile: 'Profile',
        request_callback: "طلب استدعاء",
        support_ticket: "بطاقة الدعم",
        change_password: "تغيير كلمة المرور",
        logout: "تسجيل الخروج",
    },
    pagination: {
        total_records: "إجمالي السجلات", 
    },
    side_bar: {
        dashboard: "لوحة المعلومات",
        manage_accounts: "إدارة الحسابات",
        fund: "الأموال",
        bonus: "مكافأة",
        become_a_partner: "كُن شريكًا",
        tools: "الأدوات",
        bonus_and_promotions: 'المكافأة والعروض',
    },
    success_box: {
        otp_varify: "رجاءً إدخال رقم التعريف الشخصي مرةً واحدةً، المكوَّن من 6 أرقام والمبيَّن في تطبيق مصادقة جوجل.",
        cancel: "إلغاء",
        submit: 'إرسال',
        trouble_with_2fa: "هل تواجه مشكلة في رمز المصادقة الثنائية الخاص بك؟",
        click_varify_with_email: "انقر هنا للتحقُّق من البريد الإلكتروني",
        or: "أو",
        click_here: "انقر هنا",
        to_enable_2fa: "لتمكين المصادقة الثنائية وإكمال طلبك",
        take_me_back: "اعدني",
    },
    tost_message: {
        varify_acc: "يُرجى التحقُّق من حسابك لإنشاء حساب حقيقي",
        click_to_begin: "انقر لبدء عملية التحقُّق",
    },
    proof_residence_alert: {
        you_have: "لديك",
        days_left_for_proof: "أيام متبقية لإرسال إثبات الإقامة.",
        click_here: "انقر هنا",
        to_upload: "للتحميل",
    },
    closed_trades: {
        login: "تسجيل الدخول",
        order: "طلب",
        symbol: "الرمز",
        volume: "الحجم",
        open_price: "السعر الافتتاحي",
        open_time: "الوقت المتاح",
        commission: "العمولة",
        type: 'النوع',
        sl: "SL",
        tp: "TP",
        close_price: 'السعر النهائي',
        close_time: 'وقت الإنهاء',
        swap: 'مقايضة',
        pnl: "PNL",
        comment: 'تعليق',
        no_record_found: "لا توجد سجلات",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Symbol',
        type: 'Type',
        volume: "الحجم",
        open_price: "السعر الافتتاحي",
        pnl: "PNL",
        no_record_found: "لا توجد سجلات",
    },
}